/* eslint-disable no-underscore-dangle */
import type {
  ContactRCMPublicResponse,
  ContactRCMPublicContactEvent,
  SendRcmPayload,
} from './types'

import { set } from 'lodash'

import { rcmApiInstance } from 'api'

export const sendRcm = async ({ postLeadRCMBody, property }: SendRcmPayload) => {
  const responseRcm: ContactRCMPublicResponse = await rcmApiInstance.post(
    '/public/contacts',
    postLeadRCMBody,
  )
  const eventProperties: ContactRCMPublicContactEvent = {}
  if (postLeadRCMBody.source === 'listing-syndication') {
    set(eventProperties, 'property', {
      id: property?.id,
      address: property?.address,
    })
  }
  return rcmApiInstance.post(`/public/contacts/${responseRcm?._id}/activities`, {
    owner_id: postLeadRCMBody.owner_id,
    eventName:
      postLeadRCMBody.source === 'agent-profile'
        ? 'contact-from-agent-profile'
        : 'contact-from-listing-syndication',

    eventProperties,
  })
}

export const sendRCMWithOutActivities = async ({ postLeadRCMBody, property }: SendRcmPayload) =>
  rcmApiInstance.post('/public/contacts', {
    ...postLeadRCMBody,
    meta: { ...(property ? { property: { id: property.id } } : {}) },
  })
